import './AppDownload.css';
import { APP_STORE_URL, ANDROID_DOWNLOAD_URL } from '../appLinks';

function AppDownload() {
  return (
    <div className="content invite">
      <h2 className="josefin-slab upper">Download Our App</h2>
      <p className="josefin-slab">
        For the best experience, download our wedding app.
        Available on the App Store for iOS and as a direct download for Android - you will need to trust the app to install it.
      </p>
      <div className="app-download-buttons">
        <a
          href={APP_STORE_URL}
          className="app-store-button"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Download on the App Store"
        >
          <img src="/images/app-store.svg" alt="Download on the App Store" />
        </a>
        <a
          href={ANDROID_DOWNLOAD_URL}
          className="android-button"
          aria-label="Download the Android app"
        >
          Download the<br/>Android app
        </a>
      </div>
    </div>
  );
}

export default AppDownload;
